import Vue from 'vue'
// @ts-ignore
import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)
